import React, { ChangeEvent, useEffect, useState } from "react";
import IVendor_Source from "../../../../../../models/IVendor_Source";
import OwInputWrapper from "../../../../../shared/OwInputWrapper/OwInputWrapper";
import OwLabel from "../../../../../shared/OwLabel/OwLabel";
import OwCheckbox from "../../../../../shared/OwCheckbox/OwCheckbox";
import IVendorSourceItem from "../../../../../../models/IVendorSourceItem";
import LeadTimeTypeEnum from "../../../../../../models/LeadTimeTypeEnum";
import OwSelectOption from "../../../../../shared/OwSelectOption/OwSelectOption";
import ICatalog_Item from "../../../../../../models/ICatalog_Item";
import { CatalogItemPriceBandBuilder } from "../../CatalogItemPriceBandBuilder/CatalogItemPriceBandBuilder";
import IPrice_Band_Compiled from "../../../../../../models/IPrice_Band_Compiled";
import IPrice_Group from "../../../../../../models/IPrice_Group";
import OwToggle from "@components/shared/OwToggle/OwToggle";

type Props = {
    catalogItem?: ICatalog_Item | null;
    source: IVendorSourceItem;
    index: number;
    removeSource: (source: IVendorSourceItem, index: number) => void;
    handleDefaultVendorChange: (e: ChangeEvent<any>, source: IVendorSourceItem) => void;
    defaultVendorSourceId: number | null | undefined;
    handleUpdateVendorSource: (source: IVendorSourceItem, index: number) => void;
    handleBandUpdate: (band: IPrice_Band_Compiled[], priceGroup?: IPrice_Group, vendorSource?: IVendor_Source) => void;
    band: IPrice_Band_Compiled[];
};

export const VendorSourceDetailRow = (props: Props) => {
    const leadTimeOptions = [
        { value: LeadTimeTypeEnum.DAYS, title: "Day(s)" },
        { value: LeadTimeTypeEnum.WEEKS, title: "Week(s)" },
        { value: LeadTimeTypeEnum.MONTHS, title: "Month(s)" },
    ];

    const [vendorSource, setVendorSource] = useState<IVendorSourceItem>(props.source);
    const [isDirty, setIsDirty] = useState(false);

    useEffect(() => {
        if (isDirty) {
            props.handleUpdateVendorSource(vendorSource, props.index);
            setIsDirty(false);
        }
    }, [vendorSource]);

    useEffect(() => {
        setVendorSource(props.source);
    }, [props.source]);

    const handleChange = (e: ChangeEvent<any>, source: IVendorSourceItem, index: number) => {
        const name = e.target.name;
        const value = e.target.value;

        const updatedVendorSource = {
            ...vendorSource,
            [name]: value,
        };

        setVendorSource(updatedVendorSource);
        setIsDirty(true);
    };

    console.log(
        "DEtail Row: ",
        props.defaultVendorSourceId === props.source.vendor_source_id,
        props.defaultVendorSourceId,
        props.source.vendor_source_id
    );

    return (
        <div>
            <div className={"d-flex vendor-source-row mb-5"}>
                <div className={"w-50"}>
                    <div className={vendorSource.deleteFlag ? "text-strikethrough" : ""}>
                        <i
                            className={"fas fa-trash-alt pointer text-danger"}
                            onClick={() => {
                                props.removeSource(vendorSource, props.index);
                            }}
                        />{" "}
                        {vendorSource.Vendor_Source?.name}
                    </div>
                    <div className={"mt-4"}>
                        <OwToggle
                            label={"default_vendor"}
                            name={"default_vendor"}
                            active={props.defaultVendorSourceId === props.source.vendor_source_id}
                            fn={(e) => {
                                props.handleDefaultVendorChange(e, vendorSource);
                            }}
                            labelOnRight={true}
                        />
                    </div>
                </div>
                <div className={"w-50"}>
                    <div className={"d-flex"}>
                        <div className={"w-30"}>
                            <OwInputWrapper
                                title={"lead_time"}
                                name={"lead_time"}
                                fn={(e: ChangeEvent<any>) => {
                                    handleChange(e, vendorSource, props.index);
                                }}
                                value={vendorSource.lead_time}
                            />
                        </div>
                        <div className={"ms-2"}>
                            <OwSelectOption
                                selectedOption={vendorSource}
                                selectedOptionProp={"lead_time_type"}
                                options={leadTimeOptions}
                                valueProp={"value"}
                                titleProp={"title"}
                                fn={(e: ChangeEvent<any>) => {
                                    handleChange(e, vendorSource, props.index);
                                }}
                                name={"lead_time_type"}
                                showBlankFirst={true}
                            />
                        </div>
                    </div>
                    {vendorSource.Vendor_Source?.default_lead_time ? (
                        <div className={"text-small text-muted d-flex"}>
                            <OwLabel title={"default_lead_time"} noBottomMargin={true} postText={":"} className={"me-2"} />
                            {vendorSource.Vendor_Source?.default_lead_time}
                            <OwLabel className={"ms-1"} title={vendorSource.Vendor_Source?.default_lead_time_type} noBottomMargin={true} />
                        </div>
                    ) : null}
                    <div>
                        <OwLabel title={"min_order_qty"} />
                        <OwInputWrapper
                            value={vendorSource.min_order_qty}
                            name={"min_order_qty"}
                            fn={(e: ChangeEvent<any>) => {
                                handleChange(e, vendorSource, props.index);
                            }}
                        />
                    </div>
                    <div>
                        <OwLabel title={"manuf_part_no"} />
                        <OwInputWrapper
                            value={vendorSource.manuf_part_no}
                            name={"manuf_part_no"}
                            fn={(e: ChangeEvent<any>) => {
                                handleChange(e, vendorSource, props.index);
                            }}
                        />
                    </div>
                    {props.catalogItem?.has_price_bands ? null : (
                        <div>
                            <OwLabel title={"cost"} />
                            <OwInputWrapper
                                value={vendorSource.cost_price}
                                name={"cost_price"}
                                fn={(e: ChangeEvent<any>) => {
                                    handleChange(e, vendorSource, props.index);
                                }}
                            />
                        </div>
                    )}
                </div>
            </div>
            {!props.catalogItem?.has_price_bands ? null : (
                <div className={"mt-4"}>
                    <CatalogItemPriceBandBuilder
                        catalogId={props.catalogItem.catalog_id}
                        band={props.band}
                        handleBandUpdate={props.handleBandUpdate}
                        vendorSource={vendorSource.Vendor_Source}
                    />
                </div>
            )}
        </div>
    );
};
